// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CommunityStageOrderQueryVariables = Types.Exact<{
  communityId: Types.Scalars['ID']['input'];
}>;


export type CommunityStageOrderQuery = { __typename?: 'Query', community: { __typename?: 'Community', id: string, globalPlanStageVariants: Array<{ __typename?: 'GlobalPlanStageVariant', id: string, order?: number | null | undefined, globalPlanStage: { __typename?: 'GlobalPlanStage', id: string } }> }, globalPlanStages: Array<{ __typename?: 'GlobalPlanStage', id: string, name: string }> };

export type SaveGlobalPlanStageVariantsMutationVariables = Types.Exact<{
  input: Types.SaveGlobalPlanStageVariantsInput;
}>;


export type SaveGlobalPlanStageVariantsMutation = { __typename?: 'Mutation', saveGlobalPlanStageVariants: { __typename?: 'SaveGlobalPlanStageVariantsResult', globalPlanStageVariants: Array<{ __typename?: 'GlobalPlanStageVariant', id: string, order?: number | null | undefined, globalPlanStage: { __typename?: 'GlobalPlanStage', id: string } }> } };


export const CommunityStageOrderDocument = gql`
    query CommunityStageOrder($communityId: ID!) {
  community(id: $communityId) {
    id
    globalPlanStageVariants {
      id
      order
      globalPlanStage {
        id
      }
    }
  }
  globalPlanStages {
    id
    name
  }
}
    `;

/**
 * __useCommunityStageOrderQuery__
 *
 * To run a query within a React component, call `useCommunityStageOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityStageOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityStageOrderQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityStageOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommunityStageOrderQuery, CommunityStageOrderQueryVariables> & ({ variables: CommunityStageOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunityStageOrderQuery, CommunityStageOrderQueryVariables>(CommunityStageOrderDocument, options);
      }
export function useCommunityStageOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityStageOrderQuery, CommunityStageOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunityStageOrderQuery, CommunityStageOrderQueryVariables>(CommunityStageOrderDocument, options);
        }
export function useCommunityStageOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityStageOrderQuery, CommunityStageOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunityStageOrderQuery, CommunityStageOrderQueryVariables>(CommunityStageOrderDocument, options);
        }
export type CommunityStageOrderQueryHookResult = ReturnType<typeof useCommunityStageOrderQuery>;
export type CommunityStageOrderLazyQueryHookResult = ReturnType<typeof useCommunityStageOrderLazyQuery>;
export type CommunityStageOrderSuspenseQueryHookResult = ReturnType<typeof useCommunityStageOrderSuspenseQuery>;
export type CommunityStageOrderQueryResult = Apollo.QueryResult<CommunityStageOrderQuery, CommunityStageOrderQueryVariables>;
export const SaveGlobalPlanStageVariantsDocument = gql`
    mutation SaveGlobalPlanStageVariants($input: SaveGlobalPlanStageVariantsInput!) {
  saveGlobalPlanStageVariants(input: $input) {
    globalPlanStageVariants {
      id
      order
      globalPlanStage {
        id
      }
    }
  }
}
    `;
export type SaveGlobalPlanStageVariantsMutationFn = Apollo.MutationFunction<SaveGlobalPlanStageVariantsMutation, SaveGlobalPlanStageVariantsMutationVariables>;

/**
 * __useSaveGlobalPlanStageVariantsMutation__
 *
 * To run a mutation, you first call `useSaveGlobalPlanStageVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalPlanStageVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalPlanStageVariantsMutation, { data, loading, error }] = useSaveGlobalPlanStageVariantsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalPlanStageVariantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalPlanStageVariantsMutation, SaveGlobalPlanStageVariantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalPlanStageVariantsMutation, SaveGlobalPlanStageVariantsMutationVariables>(SaveGlobalPlanStageVariantsDocument, options);
      }
export type SaveGlobalPlanStageVariantsMutationHookResult = ReturnType<typeof useSaveGlobalPlanStageVariantsMutation>;
export type SaveGlobalPlanStageVariantsMutationResult = Apollo.MutationResult<SaveGlobalPlanStageVariantsMutation>;
export type SaveGlobalPlanStageVariantsMutationOptions = Apollo.BaseMutationOptions<SaveGlobalPlanStageVariantsMutation, SaveGlobalPlanStageVariantsMutationVariables>;